const state = {
  paso: 0,
  meses: [
    'enero',
    'febrero',
    'marzo',
    'abril',
    'mayo',
    'junio',
    'julio',
    'agosto',
    'septiembre',
    'octubre',
    'noviembre',
    'diciembre',
  ],
  colonias: [
    'Guadalupe',
    'Las Americas',
    'Chapultepec Sur',
    'Chapultepec Norte',
  ],
  estados: ['Michoacán', 'Veracruz', 'Jalisco'],
  municipios: ['Morelia', 'Lagunillas', 'Patzcuaro'],
  beneficiosSocio: [
    { text: 'Acceso a creditos', icon: 'mdi-circle' },
    { text: 'Cuenta de ahorros e inversión', icon: 'mdi-circle' },
    { text: 'Auxilio en gastos funerarios', icon: 'mdi-circle' },
    { text: 'Seguro de protección de cuentas', icon: 'mdi-circle' },
    { text: 'Banca en línea', icon: 'mdi-circle' },
  ],
  sonGlobosVisibles: true,
}

const getters = {
  obtenerMesesTexto: (state) => state.meses,
  obtenerColonias: (state) => state.colonias,
  obtenerEstados: (state) => state.estados,
  obtenerMunicipios: (state) => state.municipios,
  obtenerBeneficiosSocio: (state) => state.municipios,
  obtenerSonGlobosVisibles: (state) => state.sonGlobosVisibles,
}

const mutations = {
  desabilitarGlobos(state) {
    state.sonGlobosVisibles = false
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
}
